import React from 'react';

export default function AccessDenied() {
    return <h2 align='center'>Access Denied</h2>
}